const LINKS = {
  PAGES: {
    DETAIL: {
      pl: '/:slug',
      en: '/en/:slug',
    },
    HOME: {
      pl: '/',
      en: '/en',
    },
  },
  NEWS: {
    DETAIL: {
      pl: '/aktualnosci/:slug',
      en: '/en/news/:slug',
    },
  },
  JOURNALS: {
    ARTICLE: {
      pl: '/czasopisma/:slug/artykuly/:article',
      en: '/en/journals/:slug/articles/:article',
    },
    DETAIL: {
      pl: '/czasopisma/:slug',
      en: '/en/journals/:slug',
    },
    SUBPAGE: {
      pl: '/czasopisma/:journal/podstrona/:slug',
      en: '/en/journals/:journal/subpage/:slug',
    },
    AHEAD_OF_PRINT: {
      pl: '/czasopisma/:journal/ahead-of-print',
      en: '/en/journals/:journal/ahead-of-print',
    },
    EDITORIAL_BOARD: {
      pl: '/czasopisma/:journal/sklad-redakcji',
      en: '/en/journals/:journal/editorial-board',
    },
    SCIENTIFIC_ADVISORY_BOARD: {
      pl: '/czasopisma/:journal/sklad-rady-naukowej',
      en: '/en/journals/:journal/scientific-advisory-board',
    },
    OUR_REVIEWERS: {
      pl: '/czasopisma/:journal/nasi-recenzenci',
      en: '/en/journals/:journal/our-reviewers',
    },
    NEWS: {
      pl: '/czasopisma/:journal/aktualnosci',
      en: '/en/journals/:journal/news',
    },
    NEWS_DETAIL: {
      pl: '/czasopisma/:journal/aktualnosci/:slug',
      en: '/en/journals/:journal/news/:slug',
    },
  },
  AUTHOR_CENTER_DETAIL: {
    pl: '/centrum-autorow/:slug',
    en: '/en/author-center/:slug',
  },
  ISSUES: {
    LIST: {
      pl: '/czasopisma/:slug/numery',
      en: '/en/journals/:slug/issues',
    },
    DETAIL: {
      pl: '/czasopisma/:slug/numery/:issue',
      en: '/en/journals/:slug/issues/:issue',
    },
    DETAIL_DETAIL: {
      pl: '/czasopisma/:slug/numery/:issue/:article',
      en: '/en/journals/:slug/issues/:issue/:article',
    },
    EDITORIAL_BOARD: {
      pl: '/czasopisma/:slug/numery/:issue/sklad-redakcji',
      en: '/en/journals/:slug/issues/:issue/editorial-board',
    },
    SCIENTIFIC_ADVISORY_BOARD: {
      pl: '/czasopisma/:slug/numery/:issue/sklad-rady-naukowej',
      en: '/en/journals/:slug/issues/:issue/scientific-advisory-board',
    },
  },
  COLLECTION: {
    DETAIL: {
      pl: '/kolekcje/:slug',
      en: '/en/collection/:slug',
    },
  },
  SUSTAINABLE_DEVELOPMENT_GOALS: {
    DETAIL: {
      pl: '/cele-zrownowazonego-rozwoju/:slug',
      en: '/en/sustainable-development-goals/:slug',
    },
  },
  PUBLISHING_SERIES: {
    DETAIL: {
      pl: '/serie-wydawnicze/:slug',
      en: '/en/publishing-series/:slug',
    },
  },
  AUTHORS: {
    DETAIL: {
      pl: '/autorzy/:slug',
      en: '/en/authors/:slug',
    },
  },
  EDITORS: {
    DETAIL: {
      pl: '/sklad-redakcji/:slug',
      en: '/en/editorial-composition/:slug',
    },
  },
  COUNCIL: {
    DETAIL: {
      pl: '/sklad-rady/:slug',
      en: '/en/council-composition/:slug',
    },
  },
  REVIEWERS: {
    DETAIL: {
      pl: '/nasi-recenzenci/:slug',
      en: '/en/reviewers/:slug',
    },
  },
  MONOGRAPHS: {
    DETAIL: {
      pl: '/ksiazki/:slug',
      en: '/en/books/:slug',
    },
    EDITORIAL_BOARD: {
      pl: '/ksiazki/:slug/sklad-redakcji',
      en: '/en/books/:slug/editorial-board',
    },
    REVIEWERS: {
      pl: '/ksiazki/:slug/recenzenci',
      en: '/en/books/:slug/reviewers',
    },
    CHAPTER: {
      pl: '/ksiazki/:slug/:chapter',
      en: '/en/books/:slug/:chapter',
    },
  },
}

export default LINKS
